// extracted by mini-css-extract-plugin
export default {"skills":"skills_skills__d4AdI","skillsTitle":"skills_skillsTitle__-AC2n","usingNowSkills":"skills_usingNowSkills__4JSLC","skill":"skills_skill__ghjjT","bg":"skills_bg__K3Jh5"};